import { langInputModal } from '@comp/mtcModule/mtcLangInputModal'

export const BaseTable = () => import('@comp/mtcModule/BaseTable')
export const langInput = langInputModal
export const mtcLangPopover = () => import('@comp/mtcModule/mtcLangPopover')
export const MtcSearch = () => import('@comp/mtcModule/MtcSearch.vue')